import {
	Row,
	Col,
	Card,
	Image,
	Button,
	Form,
	InputGroup,
	FormControl,
	Modal
} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	faSearch,
	faFilter,
	faTimes,
	faTimesCircle,
	faThLarge,
	faBars
} from '@fortawesome/free-solid-svg-icons'
import { v4 as uuidv4 } from 'uuid'
import { createClient } from 'graphqurl'
import EventBooth from '../../../components/EventBooth'
import EventJobs from '../../../components/EventJobs'
import Head from 'next/head'
import Link from 'next/link'
import { checkAuth } from '../../../lib/session'
import { useEffect, useState } from 'react'
import styles from '../../../styles/Event.module.scss'
import { useRouter } from 'next/router'
import moment from 'moment'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { withIronSessionSsr } from 'iron-session/next'
import { sessionOptions } from '../../../lib/session'
import { useTranslation } from 'react-i18next'

const Event = (props: any) => {
	const { t } = useTranslation()
	const data: any = props.returnObj

	const router: any = useRouter()
	let token = ''
	let profile: any = null
	if (typeof window !== 'undefined') {
		token = window.localStorage.getItem('token') as string
		profile = JSON.parse(window.localStorage.getItem('profile') as string)
	}

	const ui: string = typeof data.layout !== 'undefined' ? data.layout as string : (typeof data.event !== 'undefined' ? data.event?.defaultUI as string : 'BOOTH')
	if (typeof window !== 'undefined') {

		const now: string = new Date().toISOString()

		let deviceId = uuidv4()
		if (window.localStorage.getItem('uuid') !== null) {
			deviceId = localStorage.getItem('uuid')
		} else {
			localStorage.setItem('uuid', deviceId)
		}

		if (profile !== null) {
			
			const obj = {
				'deviceID': deviceId,
				'eventID': data.event.id as number,
				'deviceSource': 'WEB',
				'updatedAt': now,
				'applicantID': profile.id
			}
			const client = createClient({
				endpoint: process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT as string,
				headers: {
					authorization: token ? `Bearer ${token}` : ''
				}
			})
			client.query({
				query: `
					mutation($obj: [Participants_insert_input!]!) {
						insert_Participants(objects: $obj, , on_conflict: {constraint: Participants_deviceID_eventID_key, update_columns: [updatedAt, applicantID]}) {
							affected_rows
						}
					}
				`,
				variables: {
					obj: obj
				}
			})
			// .then((_res) => {
			// 	console.log(_res)
			// })
		} else {
			const obj = {
				'deviceID': deviceId,
				'eventID': data.event.id as number,
				'deviceSource': 'WEB',
				'updatedAt': now
			}
			const client = createClient({
				endpoint: process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT as string
			})
			client.query({
				query: `
					mutation($obj: [Participants_insert_input!]!) {
						insert_Participants(objects: $obj, , on_conflict: {constraint: Participants_deviceID_eventID_key, update_columns: updatedAt}) {
							affected_rows
						}
					}
				`,
				variables: {
					obj: obj
				}
			})
			// .then((_res) => {
			// 	console.log(_res)
			// })
		}
	}

	const [tempKeyword, setTempKeyword] = useState<string>('')
	const [filters, setFilters] = useState(data.filters)
	const [showFilter, setShowFilter] = useState(false)
	const [reload, setReload] = useState(false)
	const category = data.category
	const hashtag = data.hashtag
	const getSelectedCategory = (): any => {
		const tempIndex: number[] = []
		for (let i = 0; i < category.length; i++) {
			if (data.filters.jobCategories.indexOf(category[i].id) !== -1) {
				tempIndex.push(i)
			}
		}
		return tempIndex
	}
	const [selectedCategory, setSelectedCategory] = useState<number[]>(getSelectedCategory())
	const [selectedHashtag, setSelectedHashtag] = useState<string[]>(filters.hashtag)

	const handleInputChange = (event: any): any => {
		const target = event.target
		const value = target.value
		setTempKeyword(value)
	}

	const handleSubmit = (event: any): any => {
		setFilters({
			...filters,
			keyword: tempKeyword
		})
		const jobCategories: string = filters.jobCategories as string
		const jobHashtag: string = selectedHashtag.join(',')
		router.push(`/event/${data.eventId as string}?page=1&q=${tempKeyword}&c=${jobCategories}&hashtag=${jobHashtag}&layout=${ui}`)
		event.stopPropagation()
		event.preventDefault()
	}

	const handleClearKeyword = (): void => {
		setTempKeyword('')
		setFilters({
			...filters,
			keyword: ''
		})
		const jobCategories: string = filters.jobCategories as string
		const jobHashtag: string = selectedHashtag.join(',')
		router.push(`/event/${data.eventId as string}?page=1&q=&c=${jobCategories}&hashtag=${jobHashtag}&layout=${ui}`)
	}

	const updateSelectedCategory = (ref: number): void => {
		const temp: number[] = Array.from(selectedCategory)
		const index: number = selectedCategory.indexOf(ref)
		if (index !== -1) {
			temp.splice(index, 1)
			setSelectedCategory(temp)
		} else {
			temp.push(ref)
			setSelectedCategory(temp)
		}
	}

	const updateSelectedHashtag = (ref: string): void => {
		const temp: string[] = Array.from(selectedHashtag)
		const index: number = selectedHashtag.indexOf(ref)
		if (index !== -1) {
			temp.splice(index, 1)
			setSelectedHashtag(temp)
		} else {
			temp.push(ref)
			setSelectedHashtag(temp)
		}
	}

	const updateCategoryFilter = (): void => {
		const selected: number[] = selectedCategory.map((sel: number) => {
			return category[sel].id
		})
		setFilters({
			...filters,
			jobCategories: selected,
			jobHashtag: selectedHashtag,
			page: 1
		})
		const jobCategories: string = selected.join(',')
		const jobHashtag: string = selectedHashtag.join(',')
		router.push(`/event/${data.eventId as string}?page=1&q=&c=${jobCategories}&hashtag=${jobHashtag}&layout=${ui}`)
		setShowFilter(false)
	}

	const changeUI = (): void => {
		const selected: number[] = selectedCategory.map((sel: number) => {
			return category[sel].id
		})
		const jobCategories: string = selected.join(',')
		setTempKeyword('')
		setFilters({
			...filters,
			keyword: '',
			page: 1
		})
		const hashtag: string = selectedHashtag.join(',')
		router.push(`/event/${data.eventId as string}?page=1&q=&c=${jobCategories}&hashtag=${hashtag}&layout=${ui === 'LIST' ? 'BOOTH' : 'LIST'}`)
	}

	useEffect(() => {
		if (!showFilter && reload) {
			updateCategoryFilter()
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedCategory, reload])

	return (
		<>
			<Head>
				<title>{(typeof data.event !== 'undefined' && data.event !== null) ? `${data.event?.name as string} | Findjobs` : 'Findjobs'}</title>
				<meta property='og:url' content={`/event/${data.event?.id as string}`} />
				<meta property='og:type' content='article' />
				<meta property='og:title' content={data.event?.title} />
				<meta property='og:description' content={data.event?.title} />
				<meta property='og:image' content={data.event?.banner} />
				<meta name='description' content={data.event?.title} />
			</Head>
			{(data.error === false && data.noNationality === false) &&
			<Form className={styles.search} onSubmit={handleSubmit}>
				<Row>
					<Col>
						<InputGroup>	
							<InputGroup.Text className={styles.eventInputGroupText}>
								<FontAwesomeIcon icon={faSearch} />
							</InputGroup.Text>
							<FormControl
								type='text'
								size='lg'
								name='keyword'
								value={tempKeyword}
								id='inlineFormInputGroupUsername2'
								placeholder={`${t('event.search_for')} ${ui === 'LIST' ? `${t('event.jobs')}` : `${t('event.company')}`}`}
								onChange={handleInputChange}
							/>
							{tempKeyword !== '' &&
              <InputGroup.Text
              	className={styles.inputGroupText}
              	onClick={handleClearKeyword}
              >
              	<FontAwesomeIcon icon={faTimes} />
              </InputGroup.Text>
							}
						</InputGroup>
					</Col>
					<Col md={1} xs={4}>
						<Button className={styles.filterBtn} onClick={() => { setShowFilter(true) }} variant='primary' >
							<FontAwesomeIcon icon={faFilter} style={{ color: '#3A4B5F' }} />
						</Button>
						<Button className={styles.filterBtn} onClick={changeUI} variant='primary'>
							<FontAwesomeIcon icon={ui === 'LIST' ? faThLarge : faBars} style={{ color: '#3A4B5F' }} />
						</Button>
					</Col>
				</Row>
			</Form>}
			<Row>
				<Col>
					<div className='my-2'>
						{selectedCategory.map((catIndex: any) => {
							return (
								<span key={catIndex} className={styles.selectedCategory}>{category[catIndex].name}
									<Button
										size='sm'
										className={styles.removeCategoryBtn}
										value={catIndex}
										onClick={(e: any): void => {
											updateSelectedCategory(parseInt(e.currentTarget.value as string))
											setReload(true)
										}}
									>
										<FontAwesomeIcon icon={faTimesCircle} />
									</Button>
								</span>
							)
						})}
						{selectedHashtag.map((hash: any) => {
							return (
								<span key={hash} style={{ display: 'inline-block', backgroundColor: '#48494B', margin: '5px', padding: '7px 5px 2px 15px', color: 'white', borderRadius: '20px', verticalAlign: 'middle' }}>{hash}
									<Button
										size='sm'
										style={{ background: 'none', border: 'none', padding: 'none', marginLeft: '10px' }}
										value={hash}
										onClick={(e: any): void => {
											updateSelectedHashtag(e.currentTarget.value as string)
											setReload(true)
										}}
									>
										<FontAwesomeIcon style={{ width: '12px', display: 'inline-block', marginTop: '-5px' }} icon={faTimesCircle} />
									</Button>
								</span>
							)
						})}
						{(selectedCategory.length > 0 || selectedHashtag.length > 0) &&
						<span className={styles.clearCategory}>
							<Button
								size='sm'
								className={styles.clearCategoryBtn}
								onClick={(): void => {
									setSelectedCategory([])
									setSelectedHashtag([])
									setReload(true)
								}}
							>
								Clear All &nbsp;&nbsp;
								<FontAwesomeIcon icon={faTimesCircle} />
							</Button>
						</span>}
					</div>
				</Col>
			</Row>
			{/* {filters.jobCategories.length > 0 && <br />} */}
			{(data.error === true || data.noEventID === true) &&
				<Row className='justify-content-center text-center'>
					<Col>
						<Card>
							<Card.Body className={styles.cardPadding}>
								<br /><br />
								<Image src='/img/only_singaporean.png' alt='Only singaporean' />
								<br /><br /><br />
								<h2>{t('event.coming_soon')}</h2>
								<br /><br />
								<Link href='/jobs' passHref>
									<Button variant='primary' className='text-white'>{t('event.back_to_homepage')}</Button>
								</Link>
								<br /><br /><br /><br />
							</Card.Body>
						</Card>
					</Col>
				</Row>}
			{data.comingSoon === true &&
				<Row className='justify-content-center text-center'>
					<Col>
						<Card>
							<Card.Body className={styles.cardPadding}>
								<br /><br />
								<Image src='/img/only_singaporean.png' alt='Only singaporean' />
								<br /><br /><br />
								<h2>{data?.event?.name}: {t('event.will_live')} {moment(data?.event?.startDate).local().format('DD MMM YYYY')} - {moment(data?.event?.endDate).local().format('DD MMM YYYY')}.</h2>
								<br /><br />
								<Link href='/jobs' passHref>
									<Button variant='primary' className='text-white'>{t('event.back_to_homepage')}</Button>
								</Link>
								<br /><br /><br /><br />
							</Card.Body>
						</Card>
					</Col>
				</Row>}
			{data.expiredEvent === true &&
				<Row className='justify-content-center text-center'>
					<Col>
						<Card>
							<Card.Body className={styles.cardPadding}>
								<br /><br />
								<Image src='/img/only_singaporean.png' alt='Only singaporean' />
								<br /><br /><br />
								<h2>{data?.event?.name} {t('event.has_ended')}</h2>
								<br /><br />
								<Link href='/jobs' passHref>
									<Button variant='primary' className='text-white'>{t('event.back_to_homepage')}</Button>
								</Link>
								<br /><br /><br /><br />
							</Card.Body>
						</Card>
					</Col>
				</Row>}
			{(typeof data.noNationality !== 'undefined' && data.noNationality) &&
				<Row className='justify-content-center text-center'>
					<Col>
						<Card>
							<Card.Body className={styles.cardPadding}>
								<br /><br />
								<Image src='/img/only_singaporean.png' alt='Only singaporean' />
								<br /><br /><br />
								<h2>{t('event.only_singaporean')}</h2>
								<br /><br />
								<Link href='/jobs' passHref>
									<Button variant='primary' className='text-white'>{t('event.back_to_homepage')}</Button>
								</Link>
								<br /><br /><br /><br />
							</Card.Body>
						</Card>
					</Col>
				</Row>}
			{(data.error === false && typeof data.event !== 'undefined' && data.noNationality === false) &&
				<>
					{ui === 'BOOTH' && <EventBooth props={data} />}
					{ui === 'LIST' && <EventJobs props={data} />}
					{data.event.jobGroupType === 'ECDA' && (
						<a target='_blank' href='/institutes/ecda'>
							<div className={styles.trainingBtnContainer}>
								<div className={styles.trainingImgContainer}>
									<Image src='/img/trainingButton.png' className={styles.trainingImg} alt=''/>
									<Image src='/img/tapMe.png' className={styles.tapImg} alt=''/>
								</div>
							</div>
						</a>)}
				</>}
			<Modal size='lg' show={showFilter} onHide={() => { setShowFilter(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>{t('event.filter')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<h4>{t('event.choose_industry')}</h4>
					{category.map((cat: any, i: number) => {
						return <Button className={styles.categoryBtn} value={i} onClick={(e: any): void => { updateSelectedCategory(parseInt(e.target.value as string)) }} key={i} variant={selectedCategory.includes(i) ? 'primary' : 'outline-secondary'} style={{ color: selectedCategory.includes(i) ? 'white' : ''}}>{cat.name}</Button>
					})}
					<Button className={styles.categoryBtn} onClick={(): void => { setSelectedCategory(category.length === selectedCategory.length ? [] : category.map((cat: any, i: number) => { return i })) }} variant={category.length === selectedCategory.length ? 'primary' : 'outline-secondary'} style={{ color: category.length === selectedCategory.length ? 'white' : ''}}>{t('event.select_all')}</Button>
					<br />
					{hashtag.length > 0 &&
						<div>
							<hr />
							<h4 style={{ marginTop: '20px', marginBottom: '10px' }}>{t('event.choose_tag')}</h4>
							{hashtag.map((hash: any, i: number) => {
								return <Button className={styles.categoryBtn} value={hash.hashtag} onClick={(e: any): void => { updateSelectedHashtag(e.target.value as string) }} key={i} variant={selectedHashtag.includes(hash.hashtag) ? 'primary' : 'outline-secondary'}>{hash.hashtag}</Button>
							})}
							<Button className={styles.categoryBtn} onClick={(): void => { setSelectedHashtag(hashtag.length === selectedHashtag.length ? [] : hashtag.map((hash: any) => { return hash.hashtag })) }} variant={hashtag.length === selectedHashtag.length ? 'primary' : 'outline-secondary'}>{t('event.select_all')}</Button>
						</div>}
				</Modal.Body>
				<Modal.Footer>
					<Button variant='secondary' onClick={() => { setShowFilter(false) }}>
						{t('event.close')}
					</Button>
					<Button className='text-white' variant='primary' onClick={() => { updateCategoryFilter() }}>
						{t('event.submit')}
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	)
}

export const getServerSideProps = withIronSessionSsr(async function getServerSideProps ({ locale, req, query }) {
	let eventId: any = 0
	let layout = ''
	if (typeof query.id !== 'undefined') {
		eventId = query.id as string
		layout = query.layout as string
	}

	const jobCategories: string = typeof query.c !== 'undefined' ? query.c as string : ''
	const filters: any = {
		page: typeof query.page !== 'undefined' ? query.page : 1,
		keyword: typeof query.q !== 'undefined' ? query.q : '',
		jobCategories: jobCategories.split(',').filter((el: string) => {
			return el !== ''
		}).map((cat) => { return parseInt(cat) }),
		hashtag: typeof query.hashtag !== 'undefined' ? (query.hashtag as string).split(',').filter((el: string) => {
			return el !== ''
		}) : []
	}

	// Fetch data from external API
	const queryVariables: any = {}
	if (filters.jobCategories.length > 0) {
		queryVariables.jobCategories = filters.jobCategories.map(x => x)
	}
	if (filters.hashtag.length > 0) {
		queryVariables.hashtag = filters.hashtag
	}

	const client = createClient({
		endpoint: process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT as string,
		headers: {
			'X-Hasura-Admin-Secret': process.env.HASURA_ADMIN_SECRET as string
		}
	})

	// Job query
	const hasuraJobsQuery = await client.query({
		query: `
    query($jobCategories: [Int!], $hashtag: [String!]) {
      Job(limit: 10, offset: ${((filters.page as number) - 1) * 10}, order_by: {id: desc }, where: {_or: [
        {title: {_ilike: "%${filters.keyword as string}%"}},
        {description: {_ilike: "%${filters.keyword as string}%"}}
      ],
      ${filters.hashtag.length > 0 ? 'JobHashTags: {hashtag: {_in: $hashtag }}' : ''},
      ${filters.jobCategories.length > 0 ? 'Category: {id: {_in: $jobCategories}}' : ''},
      eventID: {_eq: ${eventId as number}},
      JobPlatforms: {platform: {_in: ["VCF"]}}}) {
        id
        title
        titleChinese
        titleMalay
        createdAt
        jobPostStart
        eventID
        JobHashTags {
          Hashtag {
            hashtag
            description
            color
          }
        }
        Company {
          name
          avatar
        }
        JobSalaries {
          min
          max
          jobType
          salaryType
        }
        Occupation {
          name
        }
        Category {
          name
        }
      }
      Job_aggregate(where: {title: {_ilike: "%${filters.keyword as string}%"},
      ${filters.hashtag.length > 0 ? 'JobHashTags: {hashtag: {_in: $hashtag }}' : ''}, ${filters.jobCategories.length > 0 ? 'Category: {id: {_in: $jobCategories}}' : ''}, eventID: {_eq: ${eventId as number}}, JobPlatforms: {platform: {_in: ["VCF"]}}}) {
        aggregate {
          count
        }
      }
    }
    `,
		variables: queryVariables
	})

	// Event query
	const hasuraQuery = await client.query({
		query: `
      query($jobCategories: [Int!], $hashtag: [String!]) {
        Event_by_pk(id: ${eventId as number}) {
          id
          banner
          name
          isYellowForm
          startDate
          endDate
          showCategoryFilter
          defaultUI
          isSGPROnly
          isPublicAccess
          jobGroupType
          EventReferrals {
            id
          }
        }
        Category(where: {Jobs: {Event: {id: {_eq: ${eventId as number}}}}}) {
          id
          name
        }
        Company(where: {Jobs: {Event: {id: {_eq: ${eventId as number}}}, 
          ${filters.hashtag.length > 0 ? 'JobHashTags: {hashtag: {_in: $hashtag }}' : ''}, ${filters.jobCategories.length > 0 ? 'jobCategory: {_in: $jobCategories}' : ''}}, 
          _or: [
            {name: {_ilike: "%${filters.keyword as string}%"}}, 
            {description: {_ilike: "%${filters.keyword as string}%"}}
          ]
        }, order_by: {name: asc}) {
          id
          name
          avatar
        }
        JobHashTag(distinct_on: hashtag, where: {Job: {eventID: {_eq: ${eventId as number}}}}) {
          hashtag
        }
      }
    `,
		variables: queryVariables
	})

	const hasuraRes = await hasuraQuery
	const { data: { Event_by_pk: Event, Category, JobHashTag, Company } } = hasuraRes
	// no event id
	if (Event === null) {
		const returnObj: any = {
			filters: filters,
			category: Category,
			hashtag: JobHashTag,
			noNationality: false,
			eventId: 0,
			event: null,
			jobs: {},
			layout: 'BOOTH',
			noEventID: true
		}
		return {
			props: {
				...(await serverSideTranslations(locale as string, ['common'])),
				returnObj
			}
		}
	}
	const today = new Date()
	Event.Company = Company

	if (typeof layout === 'undefined' || layout === '') {
		layout = Event.defaultUI
	}
	let ApplicantEventReferrals: any[] = []

	const { redirect } = checkAuth(req)
	// Redirect on no public access and no login
	if (Event.isPublicAccess === false) {
		if (redirect !== '') {
			return {
				redirect: {
					destination: redirect,
					permanent: false
				}
			}
		}
	}

	const returnObj: any = {
		filters: filters,
		category: Category,
		hashtag: JobHashTag,
		noNationality: false
	}
	if (today > new Date(Event.startDate) && today < new Date(Event.endDate)) {
		if (Event.isPublicAccess === true && layout === 'LIST') {
			// Get jobs
			const hasuraRes = await hasuraJobsQuery
			const { data: { Job, Job_aggregate: jobAggregate } } = hasuraRes

			// Update return object
			returnObj.eventId = eventId
			returnObj.event = Event
			returnObj.jobs = {
				jobs: Job,
				jobAggregate: jobAggregate
			}
			returnObj.layout = 'LIST'
			returnObj.error = false
		} else if (Event.isPublicAccess === false) {
			const user = req.session.user
			const getProfileQuery = await client.query({
				query: `
          query {
            Applicant_by_pk(id: ${user?.id}) {
              nationality
              ApplicantEventReferrals(where: {EventReferral: {event: {_eq: ${eventId as number}}}}) {
                id
              }
            }
          }
        `
			})

			const profileRes = await getProfileQuery
			const { data: { Applicant_by_pk: Applicant } } = profileRes
			if (Applicant !== null) {
				ApplicantEventReferrals = Applicant.ApplicantEventReferrals
				if (layout === 'LIST') {
					// Get jobs
					const hasuraRes = await hasuraJobsQuery
					const { data: { Job, Job_aggregate: jobAggregate } } = hasuraRes

					// Update return object
					returnObj.eventId = eventId
					returnObj.event = Event
					returnObj.jobs = {
						jobs: Job,
						jobAggregate: jobAggregate
					}
					returnObj.layout = 'LIST'
					returnObj.error = false
				} else if (Event.isSGPROnly === true && (Applicant.nationality === null || Applicant.nationality !== 'SG')) {
					returnObj.eventId = eventId
					returnObj.event = Event
					returnObj.jobs = {}
					returnObj.layout = 'BOOTH'
					returnObj.error = false
					returnObj.noNationality = true
					return {
						props: returnObj
					}
				} else {
					// Update return object
					returnObj.eventId = eventId
					returnObj.event = Event
					returnObj.jobs = {}
					returnObj.layout = 'BOOTH'
					returnObj.error = false
				}
			} else {
				return {
					props: {
						...(await serverSideTranslations(locale as string, ['common'])),
						returnObj
					}
				}
			}
		} else {
			// Update return object
			returnObj.eventId = eventId
			returnObj.event = Event
			returnObj.jobs = {}
			returnObj.layout = 'BOOTH'
			returnObj.error = false
		}

		if (Event.isPublicAccess === false && ApplicantEventReferrals.length === 0 && Event.EventReferrals.length > 0) {
			return {
				redirect: {
					destination: `/event/${eventId as string}/referral`,
					permanent: false
				}
			}
		} else if (layout === 'LIST' && Event.showCategoryFilter === true && typeof query.c === 'undefined') {
			return {
				redirect: {
					destination: `/event/${eventId as string}/filter`,
					permanent: false
				}
			}
		} else {
			return {
				props: {
					...(await serverSideTranslations(locale as string, ['common'])),
					returnObj
				}
			}
		}
	} else if (new Date(Event.startDate) > today) {
		returnObj.eventId = eventId
		returnObj.event = Event
		returnObj.jobs = {}
		returnObj.layout = 'BOOTH'
		returnObj.comingSoon = true
		return {
			props: {
				...(await serverSideTranslations(locale as string, ['common'])),
				returnObj
			}
		}
	} else if (today > new Date(Event.endDate)) {
		returnObj.eventId = eventId
		returnObj.event = Event
		returnObj.jobs = {}
		returnObj.layout = 'BOOTH'
		returnObj.expiredEvent = true
		return {
			props: {
				...(await serverSideTranslations(locale as string, ['common'])),
				returnObj
			}
		}
	} else {
		returnObj.eventId = eventId
		returnObj.event = Event
		returnObj.jobs = {}
		returnObj.layout = 'BOOTH'
		returnObj.error = true
		return {
			props: {
				...(await serverSideTranslations(locale as string, ['common'])),
				returnObj
			}
		}
	}
}, sessionOptions
)

export default Event
